export default __webpack_public_path__ + "static/media/Favicon-Ford-SVG.b4458f6a.svg";